import axios from 'axios';
import * as HttpStatus from 'http-status-codes';
import { getToken, login, logOut } from './auth';
import { DEFAULT_API_URL } from './shared/utils/constants';

const schoolTermAxios = (selectedTerm) => {
  axios
    .post(`${DEFAULT_API_URL}/updateselectedschoolterm`, selectedTerm, {
      headers: {
        Authorization: getToken(),
      },
    })
    .then((response) => {
      login(response.data);
      window.location.reload();
    })
    .catch((error) => {
      if (error.response.status === HttpStatus.FORBIDDEN) {
        logOut();
      }
    });
};

export default schoolTermAxios;
